// gym/GymShopSales.jsx
import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const GymShopSales = () => {
  return (
    <Box p={3}>
      <Typography variant="h4">Ventes Boutique</Typography>
      <Paper sx={{ p: 3, mt: 3 }}>
        <Typography>Page en construction...</Typography>
      </Paper>
    </Box>
  );
};

export default GymShopSales;